export default "__VITE_ASSET__BJVsbrwA__"